import Vue from 'vue'

export default function resetState(state, initialState) {
  const s = initialState
  // Loop over all keys instead of state = initialState() to avoid losing observers and reactivity
  Object.keys(s).forEach((key) => {
    Vue.set(state, key, s[key])
  })
}
